import styled from "styled-components";

export const Space = styled.div<{ size: number }>`
  min-height: ${({ size }) => size}px;
`;
